import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputDate, InputNumber, InputText} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {ClientModel, CompanyModel} from '../../../../../central/model'
import {getClient, getCompany} from '../../../../../central/services'
import {ModalAvailability} from '../../../availability/components/Modals/ModalAvailability'
import {CampModel, MasterModel, SiteModel} from '../../../modules/models'
import {getCampsService, getMasterModuleService, getSitesService} from '../../../modules/services'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {useCentralServices} from '../../../../hooks/useCentralServices'

const FormBooking: FC = () => {
  const [showModal, setShowModal] = useState(false)
  const {changeCurrentTabItem, currentTabItem} = useHoteleria()
  const {getReceptionist} = useCentralServices()
  const [company, setCompany] = useState<CompanyModel[] | any>([])
  const [client, setClient] = useState<ClientModel[] | any>([])
  const [sites, setSites] = useState<SiteModel[] | any>([])
  const [camps, setCamps] = useState<CampModel[] | any>([])
  const [moduleType, setModuleType] = useState<MasterModel[] | any>([])
  const [roomType, setRoomType] = useState<MasterModel[] | any>([])
  const [companyType, setCompanyType] = useState<MasterModel[] | any>([])
  const [contratist, setContratist] = useState<any>([])
  const [isDisabledClient, setIsDisabledClient] = useState<boolean>(false)
  const [finicio, setFinicio] = useState('')
  const [ffin, setFfin] = useState('')
  const [days, setDays] = useState()

  const {
    // reset,
    register,
    formState: {errors},
    control,
    setValue,
    setError,
    watch,
  } = useFormContext()

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      noFormDetail: false,
    }
    changeCurrentTabItem(obj)
    getCompanyList()
    getModuleTypes()
    getRoomsType()
    getCompanyTypes()
    setValue('ClienteReservaId', '')
    setValue('ContratistaId', '')

    setValue('FechaInicio', moment().format('YYYY-MM-DD'))
    setValue('FechaFin', moment().format('YYYY-MM-DD'))
    setFinicio(moment().format('YYYY-MM-DD'))
    setFfin(moment().format('YYYY-MM-DD'))
  }, [])

  const getCompanyList = async () => {
    try {
      // await new Promise((resolve) => setTimeout(resolve, 2000))
      let obj: CompanyModel = {
        isCombo: true,
      }
      const response = await getCompany(obj, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
      if (mappedSites.length === 1) {
        setValue('CompaniaId', mappedSites[0].value)
        setError('CompaniaId', {})
        await getClientList(mappedSites[0].value as string)
      }
      setCompany(mappedSites)
    } catch (error) {
      setCompany([])
    }
  }

  const getClientList = async (companyId: string) => {
    try {
      const response = await getClient({companiaId: companyId, isCombo: true}, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      if (mappedSites.length === 1) {
        setValue('ClienteId', mappedSites[0].value)
        setError('ClienteId', {})
        await getSites(mappedSites[0].value as string)
      }
      setClient(mappedSites)
    } catch (error) {
      setClient([])
    }
  }

  const getClientList2 = async () => {
    try {
      const response = await getClient({isCombo: true}, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setContratist(mappedSites)
    } catch (error) {
      setContratist([])
    }
  }
  const getContratist = async () => {
    const data = await getReceptionist(
      {
        clienteId: watch('ClienteId') || null,
        companiaId: watch('CompaniaId') || null,
        isCombo: true,
      },
      1,
      true,
    )
    setContratist(data)
  }

  const getSites = async (clientId: string) => {
    try {
      let obj: SiteModel = {
        clienteId: clientId,
        isCombo: true,
      }
      const response = await getSitesService(obj, 1)
      const data = response.data.data
      const mappedSites = data?.map((site) => ({value: site.id, label: site.nombre}))
      if (mappedSites.length === 1) {
        setValue('SiteId', mappedSites[0].value)
        setError('SiteId', {})
        await getCamps(mappedSites[0].value as string)
      }
      setSites(mappedSites)
    } catch (error) {
      setSites([])
    }
  }

  const getCamps = async (siteId: string) => {
    try {
      let obj: CampModel = {
        id: '',
        nombre: '',
        siteId: siteId,
        clienteId: '',
        companiaId: '',
        site: '',
        nombreCliente: '',
        nombreCompania: '',
      }
      const response = await getCampsService(obj, 1)
      const data = response.data.data
      const mappedCamps = data?.map((camp) => ({value: camp.id, label: camp.nombre}))
      if (mappedCamps.length === 1) {
        setValue('CampamentoId', mappedCamps[0].value)
        setError('CampamentoId', {})
      }
      setCamps(mappedCamps)
    } catch (error) {
      setCamps([])
    }
  }

  const getCompanyTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoEmpresa',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setCompanyType(mappedModuleTypes)
    } catch (error) {
      setCompanyType([])
    }
  }

  const getModuleTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoModulo',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setModuleType(mappedModuleTypes)
    } catch (error) {
      setModuleType([])
    }
  }

  const getRoomsType = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoHabitacion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setRoomType(mappedMaster)
    } catch (error) {
      setRoomType([])
    }
  }

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})

    getClientList(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)

    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSites(value)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)

    setValue('CampamentoId', '')

    getCamps(value)

    setError('SiteId', {})
  }

  const handleCampChange = (val: any) => {
    let value = val ? val.value : ''
    // setValueCamp(value)
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
  }

  const handleCompanyTypeChange = (val: any) => {
    let value = val ? val.value : ''
    let clienteValue = watch('ClienteId')
    setValue('TipoEmpresaId', value)
    setError('TipoEmpresaId', {})
    console.log({value})

    if (value === 'nZ3Yr0J0@XM=') {
      if (clienteValue) {
        setValue('ContratistaId', '')
        setValue('ClienteReservaId', clienteValue)
        setValue('ClienteContratista', clienteValue)
        setError('ClienteContratista', {})
      } else {
        setValue('ContratistaId', '')
        setValue('ClienteReservaId', '')
        setValue('ClienteContratista', '')
      }
      getClientList2()
      setIsDisabledClient(true)
    }
    if (value === 'AB4H6VhVfYc=') {
      setIsDisabledClient(false)
      setValue('ContratistaId', '')
      setValue('ClienteReservaId', '')
      setValue('ClienteContratista', '')
      getContratist()
    }

    //AB4H6VhVfYc= -> Contratista
    //nZ3Yr0J0@XM= -> Cliente
  }

  const handleClientContratistChange = (val: any) => {
    let value = val ? val.value : ''
    const companyType = watch('TipoEmpresaId')
    setValue('ClienteContratista', value)
    setError('ClienteContratista', {})
    if (companyType === 'nZ3Yr0J0@XM=') {
      // si es cliente
      setValue('ClienteReservaId', value)
      setValue('ContratistaId', '')
    }
    if (companyType === 'AB4H6VhVfYc=') {
      // si es contratista
      setValue('ClienteReservaId', '')
      setValue('ContratistaId', value)
    }
  }

  const handleTypeModuleChange = (val: any) => {
    let value = val ? val.value : ''
    const labelSelected = moduleType?.find((item: any) => item.value === value)?.label
    const valueRoom = roomType?.find((item: any) => item.label === labelSelected)?.value
    setValue('TipoModuloId', value)
    setError('TipoModuloId', {})
    setValue('TipoHabitacionId', valueRoom)
    // getModuleById(value)
  }

  const handleGetFirstDate = (e: any) => {
    setError('FechaInicio', {})
    setFinicio(e.target.value)
  }

  const handleGetSecondDate = (e: any) => {
    setError('FechaFin', {})
    setFfin(e.target.value)
  }

  useEffect(() => {
    if (finicio && ffin) {
      const inicio = moment(finicio)
      const fin = moment(ffin)
      const diff = fin.diff(inicio, 'days') + 1
      if (diff < 0) {
        setDays(0 as any)
      } else {
        setDays(diff as any)
      }
    }
  }, [finicio, ffin])

  return (
    <div className='sdx_form card p-4'>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Compañia:</label>
          <Select
            control={control}
            name='CompaniaId'
            data={company}
            errors={errors}
            onChangeValue={handleCompanyChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Cliente:</label>
          <Select
            control={control}
            name='ClienteId'
            data={client}
            errors={errors}
            onChangeValue={handleClientChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Site:</label>
          <Select
            control={control}
            name='SiteId'
            data={sites}
            errors={errors}
            onChangeValue={handleSiteChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Campamento:</label>
          <Select
            control={control}
            name='CampamentoId'
            data={camps}
            errors={errors}
            onChangeValue={handleCampChange}
          />
        </div>
      </div>

      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Tipo de Empresa:</label>
          <Select
            control={control}
            name='TipoEmpresaId'
            data={companyType}
            errors={errors}
            onChangeValue={handleCompanyTypeChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Cliente/Contratista:</label>
          <Select
            control={control}
            name='ClienteContratista'
            data={contratist}
            errors={errors}
            onChangeValue={handleClientContratistChange}
            disabled={isDisabledClient}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Tipo de Módulo:</label>
          <Select
            control={control}
            name='TipoModuloId'
            data={moduleType}
            errors={errors}
            onChangeValue={handleTypeModuleChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Tipo de Habitación:</label>
          <Select control={control} name='TipoHabitacionId' data={roomType} errors={errors} />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Fecha Inicio:</label>
          <InputDate
            name='FechaInicio'
            register={register}
            errors={errors}
            minValue={moment().format('YYYY-MM-DD')}
            onChange={(e: any) => handleGetFirstDate(e)}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Fecha Fin:</label>
          <InputDate
            name='FechaFin'
            register={register}
            errors={errors}
            minValue={moment().format('YYYY-MM-DD')}
            onChange={(e: any) => handleGetSecondDate(e)}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label className=''>Cant. de Dias:</label>
          <div className='sdx_form_input'>
            <div>{days}</div>
          </div>
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label className=''>Etiqueta:</label>
          <InputText
            name='Etiqueta'
            textPlaceholder='Escribe la Etiqueta'
            register={register}
            errors={errors}
          />
        </div>
        {/* <div className='col-sm-12 col-lg-3 d-flex align-items-end pb-3'>
          <Button
            typeBtn='button'
            label='Ver disponibilidad'
            classNameProp='me-5 w-150px text-center d-flex justify-content-center'
            onClick={() => setShowModal(true)}
          />
        </div> */}
      </div>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Nro de Camas:</label>
          <InputNumber
            name='NroCamas'
            textPlaceholder='Escribe el Nro de Camas'
            register={register}
            errors={errors}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Ocupabilidad de Huespedes Masculinos:</label>
          <InputNumber
            name='NroHuespedHombre'
            textPlaceholder='Escribe la Ocupabilidad de Huespedes Masculinos'
            register={register}
            errors={errors}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Ocupabilidad de Huespedes Femeninos:</label>
          <InputNumber
            name='NroHuespedMujer'
            textPlaceholder='Escribe la Ocupabilidad de Huespedes Femeninos'
            register={register}
            errors={errors}
          />
        </div>
      </div>

      {showModal ? <ModalAvailability show={showModal} setShow={setShowModal} /> : <></>}
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div>
  )
}

export {FormBooking}
